export const SESSION_EXPIRED_MESSAGE = "Your session has expired. Please log in again to continue.";

const TOKEN_EXPIRED_PATTERN = /token\s+has\s+expired(?:,|\.|\s)*please\s+log\s*in\s+again/i;

export const normalizeSessionErrorMessage = (message) => (
  typeof message === "string" && TOKEN_EXPIRED_PATTERN.test(message)
    ? SESSION_EXPIRED_MESSAGE
    : message
);
